module.exports = __webpack_public_path__ + "img/game_mov.f2ef197c.png";